import * as React from 'react';
import { ProductListProduct } from '../../product-list-component/product-list-component';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { LifecycleStatus } from '../../../shared-utils/lifecycle-status';

function getAvailabilityClassName(product: ProductListProduct, simpleProduct: SimpleProduct | undefined): string {
    const lifeCycleStatus = simpleProduct?.ExtensionProperties?.find(x => x.Key === 'PRODUCTLIFECYCLESTATEID')?.Value?.StringValue;

    if (!simpleProduct) {
        return 'retrieving';
    }

    if (lifeCycleStatus === LifecycleStatus.OutOfSeason) {
        return 'hidden';
    }

    if (!product.Availability) {
        return '    ';
    }

    if (product.Availability.StockLevelLabel?.startsWith('!')) {
        return 'available';
    }

    if (product.Availability.IsProductAvailable) {
        return 'available';
    }

    if (product.Availability.StockLevelCode === 'ERR') {
        return 'error';
    }

    return 'not-available';
}

export const Availability: React.FC<{
    baseClassName: string;
    product: ProductListProduct;
    simpleProduct: SimpleProduct | undefined
}> = ({
    baseClassName,
    product,
    simpleProduct
}) => {
    const className = getAvailabilityClassName(product, simpleProduct);
    const stockLevelLabel = product.Availability?.StockLevelLabel?.startsWith('!')
        ? product.Availability?.StockLevelLabel?.substring(1)
        : product.Availability?.StockLevelLabel;
    const availabilityText = className === 'hidden'
        ? '    '
        : stockLevelLabel || (className === 'error' ? 'ERROR' : '');

    const ref = React.useRef<HTMLDivElement>(null);
    const [containerWidth, setContainerWidth] = React.useState<number | undefined>(undefined);

    // Get actual width (ignoring hidden overflow) of the container on load and set variable --max-width so that transition is more accurate
    React.useEffect(() => {
        if (ref.current) {
            const width = ref.current.scrollWidth;
            setContainerWidth(width);
        }
    }, [product.Availability?.StockLevelLabel]);

    return (
        <div style={{ height: 20, width: 20, position: 'relative' }}>
            <div className={`${baseClassName}__availability ${className}`} ref={ref} style={containerWidth ? { '--max-width': `${containerWidth}px` } as React.CSSProperties : undefined}>
                <div className={`${baseClassName}__availability-indicator`} />
                <div className={`${baseClassName}__availability-text`}>{availabilityText}</div>
            </div>
        </div>
    );
};

export default Availability;
